"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetGroupRelateToSportId = exports.useGetHotProbsSportMarketOutcomeTypes = void 0;
const react_redux_1 = require("react-redux");
const react_1 = require("react");
const CommonDataProvider_1 = require("../containers/CommonDataProvider");
const DEFAULT_GROUP_ID = 1;
const useGetHotProbsSportMarketOutcomeTypes = ({ sportId, platformType = 'desktop', }) => {
    var _a;
    const sportsGroups = (0, react_redux_1.useSelector)(CommonDataProvider_1.selectHotProbabilitiesGroupsSports);
    const groups = (0, react_redux_1.useSelector)(CommonDataProvider_1.selectHotProbabilitiesGroups);
    if (!groups || !sportsGroups)
        return {};
    const { groupId } = sportsGroups.find((item) => item.sportId === sportId && item[platformType]) || { groupId: DEFAULT_GROUP_ID };
    const MARKETS = (_a = groups[groupId]) === null || _a === void 0 ? void 0 : _a.markets;
    const outcomeTypes = MARKETS === null || MARKETS === void 0 ? void 0 : MARKETS.map((name) => CommonDataProvider_1.HOT_PROBS_MARKETS_OUTCOMES_MAP[name]).flat();
    return { outcomeTypes, groupId };
};
exports.useGetHotProbsSportMarketOutcomeTypes = useGetHotProbsSportMarketOutcomeTypes;
const useGetGroupRelateToSportId = ({ sportId, platform, }) => {
    const groups = (0, react_redux_1.useSelector)(CommonDataProvider_1.selectHotProbabilitiesGroups);
    const res = (0, react_1.useMemo)(() => {
        var _a;
        return (!!sportId &&
            ((_a = Object.values(groups)) === null || _a === void 0 ? void 0 : _a.find(({ sports }) => !!Object.values(sports).find((sport) => `${sport.sportId}` === `${sportId}` && sport[platform]))));
    }, [groups, platform, sportId]);
    return res || groups[DEFAULT_GROUP_ID];
};
exports.useGetGroupRelateToSportId = useGetGroupRelateToSportId;
//# sourceMappingURL=useGetHotProbsSportMarketOutcomeTypes.js.map